import React,{useState} from 'react'
import { useEffect } from 'react';
import { showData } from '../../Utils/APIs/commonShowAPI';

const Index = () => {
    const [images, setImages] = useState([]);
    const [fullscreen, setFullscreen] = useState(null);
    const [saralId, setSaralId] = useState("");
    const [btnClick, setBtnClick] = useState(false);
      useEffect(() => {
    async function fetchImages() {
      if (!saralId) return; // don't call if saralId is empty
      await showData(`service/showImage?saralId=${saralId}`, setImages);
    }

    if (btnClick) {
      fetchImages();
      setBtnClick(false); // reset after fetch
    }
  }, [btnClick, saralId]);
  return (
    <div className="p-6 overflow-auto h-full w-full">
      {/* Input + Button */}
      <div className="flex gap-2 mb-4">
        <input
          type="text"
          placeholder="Enter Saral ID"
          value={saralId}
          onChange={(e) => setSaralId(e.target.value)}
          className="border p-2 rounded w-64"
        />
        <button
          onClick={()=> setBtnClick(true)}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Fetch Images
        </button>
      </div>

      {/* Show Images */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {images?.map((img, index) => (
            <img
              src={`https://service.galosolar.com/api/${img}`}
              alt={`img-${index}`}
              className="w-full h-40 object-cover rounded-lg shadow-md"
              onClick={() => setFullscreen(`https://service.galosolar.com/api/${img}`)}
            />
        ))}
      </div>
      {fullscreen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
          onClick={() => setFullscreen(null)}
        >
          <img
            src={fullscreen}
            alt="fullscreen"
            className="max-h-[90%] max-w-[90%] rounded-lg shadow-lg"
          />
        </div>
      )}
    </div>
  )
}

export default Index